import { GameAssets } from "@ak/game-assets"

export const Client = GameAssets.create({ locale: "jp" })
